import { Type } from '@sinclair/typebox';

export const CountryCode = Type.Union([
    Type.Literal('USA'),
    Type.Literal('ABW'),
    Type.Literal('AFG'),
    Type.Literal('AGO'),
    Type.Literal('AIA'),
    Type.Literal('ALA'),
    Type.Literal('ALB'),
    Type.Literal('AND'),
    Type.Literal('ARE'),
    Type.Literal('ARG'),
    Type.Literal('ARM'),
    Type.Literal('ASM'),
    Type.Literal('ATA'),
    Type.Literal('ATF'),
    Type.Literal('ATG'),
    Type.Literal('AUS'),
    Type.Literal('AUT'),
    Type.Literal('AZE'),
    Type.Literal('BDI'),
    Type.Literal('BEL'),
    Type.Literal('BEN'),
    Type.Literal('BES'),
    Type.Literal('BFA'),
    Type.Literal('BGD'),
    Type.Literal('BGR'),
    Type.Literal('BHR'),
    Type.Literal('BHS'),
    Type.Literal('BIH'),
    Type.Literal('BLM'),
    Type.Literal('BLR'),
    Type.Literal('BLZ'),
    Type.Literal('BMU'),
    Type.Literal('BOL'),
    Type.Literal('BRA'),
    Type.Literal('BRB'),
    Type.Literal('BRN'),
    Type.Literal('BTN'),
    Type.Literal('BVT'),
    Type.Literal('BWA'),
    Type.Literal('CAF'),
    Type.Literal('CAN'),
    Type.Literal('CCK'),
    Type.Literal('CHE'),
    Type.Literal('CHL'),
    Type.Literal('CHN'),
    Type.Literal('CIV'),
    Type.Literal('CMR'),
    Type.Literal('COD'),
    Type.Literal('COG'),
    Type.Literal('COK'),
    Type.Literal('COL'),
    Type.Literal('COM'),
    Type.Literal('CPV'),
    Type.Literal('CRI'),
    Type.Literal('CUB'),
    Type.Literal('CUW'),
    Type.Literal('CXR'),
    Type.Literal('CYM'),
    Type.Literal('CYP'),
    Type.Literal('CZE'),
    Type.Literal('DEU'),
    Type.Literal('DJI'),
    Type.Literal('DMA'),
    Type.Literal('DNK'),
    Type.Literal('DOM'),
    Type.Literal('DZA'),
    Type.Literal('ECU'),
    Type.Literal('EGY'),
    Type.Literal('ERI'),
    Type.Literal('ESH'),
    Type.Literal('ESP'),
    Type.Literal('EST'),
    Type.Literal('ETH'),
    Type.Literal('FIN'),
    Type.Literal('FJI'),
    Type.Literal('FLK'),
    Type.Literal('FRA'),
    Type.Literal('FRO'),
    Type.Literal('FSM'),
    Type.Literal('GAB'),
    Type.Literal('GBR'),
    Type.Literal('GEO'),
    Type.Literal('GGY'),
    Type.Literal('GHA'),
    Type.Literal('GIB'),
    Type.Literal('GIN'),
    Type.Literal('GLP'),
    Type.Literal('GMB'),
    Type.Literal('GNB'),
    Type.Literal('GNQ'),
    Type.Literal('GRC'),
    Type.Literal('GRD'),
    Type.Literal('GRL'),
    Type.Literal('GTM'),
    Type.Literal('GUF'),
    Type.Literal('GUM'),
    Type.Literal('GUY'),
    Type.Literal('HKG'),
    Type.Literal('HMD'),
    Type.Literal('HND'),
    Type.Literal('HRV'),
    Type.Literal('HTI'),
    Type.Literal('HUN'),
    Type.Literal('IDN'),
    Type.Literal('IMN'),
    Type.Literal('IND'),
    Type.Literal('IOT'),
    Type.Literal('IRL'),
    Type.Literal('IRN'),
    Type.Literal('IRQ'),
    Type.Literal('ISL'),
    Type.Literal('ISR'),
    Type.Literal('ITA'),
    Type.Literal('JAM'),
    Type.Literal('JEY'),
    Type.Literal('JOR'),
    Type.Literal('JPN'),
    Type.Literal('KAZ'),
    Type.Literal('KEN'),
    Type.Literal('KGZ'),
    Type.Literal('KHM'),
    Type.Literal('KIR'),
    Type.Literal('KNA'),
    Type.Literal('KOR'),
    Type.Literal('KWT'),
    Type.Literal('LAO'),
    Type.Literal('LBN'),
    Type.Literal('LBR'),
    Type.Literal('LBY'),
    Type.Literal('LCA'),
    Type.Literal('LIE'),
    Type.Literal('LKA'),
    Type.Literal('LSO'),
    Type.Literal('LTU'),
    Type.Literal('LUX'),
    Type.Literal('LVA'),
    Type.Literal('MAC'),
    Type.Literal('MAF'),
    Type.Literal('MAR'),
    Type.Literal('MCO'),
    Type.Literal('MDA'),
    Type.Literal('MDG'),
    Type.Literal('MDV'),
    Type.Literal('MEX'),
    Type.Literal('MHL'),
    Type.Literal('MKD'),
    Type.Literal('MLI'),
    Type.Literal('MLT'),
    Type.Literal('MMR'),
    Type.Literal('MNE'),
    Type.Literal('MNG'),
    Type.Literal('MNP'),
    Type.Literal('MOZ'),
    Type.Literal('MRT'),
    Type.Literal('MSR'),
    Type.Literal('MTQ'),
    Type.Literal('MUS'),
    Type.Literal('MWI'),
    Type.Literal('MYS'),
    Type.Literal('MYT'),
    Type.Literal('NAM'),
    Type.Literal('NCL'),
    Type.Literal('NER'),
    Type.Literal('NFK'),
    Type.Literal('NGA'),
    Type.Literal('NIC'),
    Type.Literal('NIU'),
    Type.Literal('NLD'),
    Type.Literal('NOR'),
    Type.Literal('NPL'),
    Type.Literal('NRU'),
    Type.Literal('NZL'),
    Type.Literal('OMN'),
    Type.Literal('PAK'),
    Type.Literal('PAN'),
    Type.Literal('PCN'),
    Type.Literal('PER'),
    Type.Literal('PHL'),
    Type.Literal('PLW'),
    Type.Literal('PNG'),
    Type.Literal('POL'),
    Type.Literal('PRI'),
    Type.Literal('PRK'),
    Type.Literal('PRT'),
    Type.Literal('PRY'),
    Type.Literal('PSE'),
    Type.Literal('PYF'),
    Type.Literal('QAT'),
    Type.Literal('REU'),
    Type.Literal('ROU'),
    Type.Literal('RUS'),
    Type.Literal('RWA'),
    Type.Literal('SAU'),
    Type.Literal('SDN'),
    Type.Literal('SEN'),
    Type.Literal('SGP'),
    Type.Literal('SGS'),
    Type.Literal('SHN'),
    Type.Literal('SJM'),
    Type.Literal('SLB'),
    Type.Literal('SLE'),
    Type.Literal('SLV'),
    Type.Literal('SMR'),
    Type.Literal('SOM'),
    Type.Literal('SPM'),
    Type.Literal('SRB'),
    Type.Literal('SSD'),
    Type.Literal('STP'),
    Type.Literal('SUR'),
    Type.Literal('SVK'),
    Type.Literal('SVN'),
    Type.Literal('SWE'),
    Type.Literal('SWZ'),
    Type.Literal('SXM'),
    Type.Literal('SYC'),
    Type.Literal('SYR'),
    Type.Literal('TCA'),
    Type.Literal('TCD'),
    Type.Literal('TGO'),
    Type.Literal('THA'),
    Type.Literal('TJK'),
    Type.Literal('TKL'),
    Type.Literal('TKM'),
    Type.Literal('TLS'),
    Type.Literal('TON'),
    Type.Literal('TTO'),
    Type.Literal('TUN'),
    Type.Literal('TUR'),
    Type.Literal('TUV'),
    Type.Literal('TWN'),
    Type.Literal('TZA'),
    Type.Literal('UGA'),
    Type.Literal('UKR'),
    Type.Literal('UMI'),
    Type.Literal('URY'),
    Type.Literal('UZB'),
    Type.Literal('VAT'),
    Type.Literal('VCT'),
    Type.Literal('VEN'),
    Type.Literal('VGB'),
    Type.Literal('VIR'),
    Type.Literal('VNM'),
    Type.Literal('VUT'),
    Type.Literal('WLF'),
    Type.Literal('WSM'),
    Type.Literal('YEM'),
    Type.Literal('ZAF'),
    Type.Literal('ZMB'),
    Type.Literal('ZWE'),
]);

export const MonetaryValueWithNanos = Type.Object({
    units: Type.Optional(Type.String()),
    nanos: Type.Optional(Type.Integer()),
    currency: Type.Optional(Type.Literal('USD')),
});

export const NumericValueWithNanos = Type.Object({
    units: Type.Optional(Type.String()),
    nanos: Type.Optional(Type.Integer()),
});

export const MonetaryValue = Type.Object({
    amount: Type.Optional(Type.Number()),
    currency: Type.Literal('USD'),
});

export const RefLink = Type.Object({
    id: Type.Optional(Type.String()),
    href: Type.Optional(Type.String()),
});

export const StateCode = Type.Union([
    Type.Literal('US_CA'),
    Type.Literal('US_AL'),
    Type.Literal('US_AK'),
    Type.Literal('US_AZ'),
    Type.Literal('US_AR'),
    Type.Literal('US_CO'),
    Type.Literal('US_CT'),
    Type.Literal('US_DE'),
    Type.Literal('US_DC'),
    Type.Literal('US_FL'),
    Type.Literal('US_GA'),
    Type.Literal('US_HI'),
    Type.Literal('US_ID'),
    Type.Literal('US_IL'),
    Type.Literal('US_IN'),
    Type.Literal('US_IA'),
    Type.Literal('US_KS'),
    Type.Literal('US_KY'),
    Type.Literal('US_LA'),
    Type.Literal('US_ME'),
    Type.Literal('US_MD'),
    Type.Literal('US_MA'),
    Type.Literal('US_MI'),
    Type.Literal('US_MN'),
    Type.Literal('US_MS'),
    Type.Literal('US_MO'),
    Type.Literal('US_MT'),
    Type.Literal('US_NE'),
    Type.Literal('US_NV'),
    Type.Literal('US_NH'),
    Type.Literal('US_NJ'),
    Type.Literal('US_NM'),
    Type.Literal('US_NY'),
    Type.Literal('US_NC'),
    Type.Literal('US_ND'),
    Type.Literal('US_OH'),
    Type.Literal('US_OK'),
    Type.Literal('US_OR'),
    Type.Literal('US_PA'),
    Type.Literal('US_RI'),
    Type.Literal('US_SC'),
    Type.Literal('US_SD'),
    Type.Literal('US_TN'),
    Type.Literal('US_TX'),
    Type.Literal('US_UT'),
    Type.Literal('US_VT'),
    Type.Literal('US_VA'),
    Type.Literal('US_WA'),
    Type.Literal('US_WV'),
    Type.Literal('US_WI'),
    Type.Literal('US_WY'),
]);

export const Address = Type.Object({
    country_code: CountryCode,
    street: Type.String(),
    additional: Type.Optional(Type.String()),
    city: Type.String(),
    region: Type.String(),
    postal_code: Type.String(),
});

export const ChangeInfo = Type.Object({
    amount: Type.Optional(Type.Number()),
    percentage: Type.Optional(Type.Number()),
});

export const DateFilter = Type.Union([
    Type.Literal('created_timestamp'),
    Type.Literal('modified_timestamp'),
]);

export const SortBy = Type.Union([
    Type.Literal('created_timestamp'),
    Type.Literal('modified_timestamp'),
]);

export const SortOrder = Type.Union([
    Type.Literal('ascending'),
    Type.Literal('descending'),
]);

export const GovernmentId = Type.Object({
    country: CountryCode,
    type: Type.Union([
        Type.Literal('passport'),
        Type.Literal('drivers_license'),
        Type.Literal('identification_card'),
        Type.Literal('tax_id'),
    ]),
    number: Type.String(),
});

// Keep this in sync with the atomic.position_class enum in the database
export const AssetClass = Type.Union([
    Type.Literal('OTHER'),
    Type.Literal('COMMON_STOCK'),
    Type.Literal('FOREIGN_STOCK'),
    Type.Literal('FOREIGN_BOND'),
    Type.Literal('CASH'),
    Type.Literal('REAL_ESTATE'),
    Type.Literal('BOND'),
    Type.Literal('CRYPTO'),
    Type.Literal('MUTUAL_FUND'),
    Type.Literal('OPTION'),
    Type.Literal('EXCHANGE_TRADED_PRODUCT'),
    Type.Literal('ALTERNATIVE'),
    Type.Literal('STRUCTURED_PRODUCT'),
]);
